import loadable from '@loadable/component';

import { Modules } from '../../types';

export const loadStreamModule: () => Promise<
    Modules['stream']
> = /* #__LOADABLE__ */ () =>
    import(/* webpackChunkName: "stream-module" */ './index');

export const AsyncStream = loadable(loadStreamModule, {
    resolveComponent: ({ default: stream }) => stream.components.Stream,
});

export const AsyncPersistentStream = loadable(loadStreamModule, {
    resolveComponent: ({ default: stream }) =>
        stream.components.PersistentStream,
});

export const AsyncStreamPlayer = loadable(loadStreamModule, {
    resolveComponent: ({ default: stream }) => stream.components.StreamPlayer,
});
